<template>

  <div class="video-player-container">

    <!-- 播放按钮 -->
    <div v-if="!videoPlay" class="video-play-btn" @click="playVideo">
      <icon-svg class="icon-play" name="video-play"></icon-svg>
    </div>

    <!-- 视频层 -->
    <video-player class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      style="width: 100%;height: 100%"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)">
    </video-player>
  </div>
</template>

<script>

export default {
  name: "Video",
  data() {
    return {
      videoPlay: false, // 视频是否播放
      playerOptions: {
        muted: false,
        autoplay: false,
        loop: false,
        controls: true,
        preload: true,
        poster: require('../../assets/images/jobs/video-poster.png'), //封面地址
        sources: [
          {
            type: "video/mp4",
            src: "http://zhaopin.winning-health.com.cn/static/media/campus-video.mp4",
          },
        ],
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  mounted() {
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    isOtherBrowser(){
      let ua = window.navigator.userAgent.toLocaleLowerCase() || ''
      return  ua.indexOf('qqbrowser') !== -1 || ua.indexOf('ucbrowser') !==-1
    }
  },
  methods: {
    // 播放暂停视频
    playVideo() {
      this.videoPlay
        ? this.player && this.player.pause()
        : this.player && this.player.play()
    },

    // 播放回调
    onPlayerPlay() {
      this.videoPlay = true
    },
    // 暂停回调
    onPlayerPause() {
      this.videoPlay = false
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* 隐藏播放按钮 */
.video-js .vjs-big-play-button {
  display: none !important;
}
/* 修正进度条位置 */
.video-js .vjs-control-bar{
 bottom: 0px !important;
 height: 20px !important;
}
/* 修正进度条圆点位置 */
.video-js .vjs-play-progress:before {
  top: -5px !important;
}
/* 修正时间文字位置 */
.video-js .vjs-time-control{
  display: flex;
  align-items: center;
}

/* 显示时间 */
.video-js .vjs-current-time, .video-js .vjs-duration{
  display: unset !important;
  display: flex;
  align-items: center;
  height: 20px !important;
  line-height: 20px !important;
}



</style>

<style scoped>

::v-deep .vjs-button > .vjs-icon-placeholder:before{
  font-size:15px;
  line-height:20px;
}

::v-deep .video-js .vjs-time-control{
  font-size:10px;
  padding-left:2px;
  padding-right:2px;
}

::v-deep .video-js  .vjs-time-divider{
  min-width:3px;
}

::v-deep .video-js .vjs-progress-holder{
  height:4px;
}

::v-deep .video-js .vjs-play-progress:before{
  font-size:13px;
}

.video-player-container {
  position: relative;
  height: 100%;
}

::v-deep .video-js {
  width: 100%;
  height: 100%;
}

.video-play-btn {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.icon-play{
  width: 40px;
  height: 40px;
}

.flex-1 {
  flex: 1;
}
</style>
